module.exports = __webpack_public_path__ + "static/img/policy-header.6af7d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-header.png
// module id = q4vx
// module chunks = 0